import dayjs from "dayjs";

const isValidMonth = (value) => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 12;

const monthInRange = (month, startMonth, endMonth) => {
  if (!isValidMonth(month) || !isValidMonth(startMonth) || !isValidMonth(endMonth)) return false;
  const m = Number(month);
  const s = Number(startMonth);
  const e = Number(endMonth);
  if (s <= e) return m >= s && m <= e;
  return m >= s || m <= e; // wraps across year boundary (e.g., Nov -> Mar)
};

export const getSeasonPhase = (program, now = dayjs()) => {
  if (!program) return "off_season";
  const currentMonth = now.month() + 1; // dayjs month is 0-based
  const inStart = Number(program.in_season_start_month);
  const inEnd = Number(program.in_season_end_month);

  if (!isValidMonth(inStart) || !isValidMonth(inEnd)) return "off_season";
  return monthInRange(currentMonth, inStart, inEnd) ? "in_season" : "off_season";
};

export const getSeasonWorkoutGuidance = (phase) => {
  if (phase === "in_season") {
    return {
      phase: "in_season",
      label: "In-Season",
      intensity: "moderate",
      emphasis:
        "Shorter sessions with higher game-like scenarios, decision speed, and execution quality under pressure.",
      recommendedWorkoutLength: 45,
    };
  }

  return {
    phase: "off_season",
    label: "Off-Season",
    intensity: "low_to_moderate",
    emphasis:
      "Lower-intensity sessions focused on skill acquisition, repetition quality, and controlled progression.",
    recommendedWorkoutLength: 60,
  };
};
